import { render, staticRenderFns } from "./DeliveryInfoChannel.vue?vue&type=template&id=0d4e0bd6&"
import script from "./DeliveryInfoChannel.vue?vue&type=script&lang=ts&"
export * from "./DeliveryInfoChannel.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryInfoChannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports